<a
  [attr.href]="to ? to : null"
  [target]="template === 'external' ? '_blank' : '_self'"
  [attr.rel]="template === 'external' ? 'noopener noreferrer' : null"
  (click)="navigateInternal($event)">
  <div class="small-card -card-container" [ngClass]="mode === 'potrait' ? '-mode-potrait' : '-mode-landscape'">
    <div class="small-card -image-container">
      <img [src]="image" alt="Small card image" />
    </div>
    <div class="small-card -card-details">
      <div class="-pill-section">
        @if (tag) {
        <content-tag [label]="tag"></content-tag>
        } @if (indicators?.length) { @for (indicator of indicators; track indicator) {
        <app-indicator-chip-wrapper [indicator]="indicator"> </app-indicator-chip-wrapper>
        } }
      </div>

      <ng-content></ng-content>
    </div>
  </div>
</a>
